
import React, { Component } from 'react';
import './setup-class.scss'

import SchoolApi from '../../../apis/school'
import PillButton from '../../common/pill-button-select/pill-button-select'
import AddSection from '../add-section/add-section'
import Dropdown from '../../common/dropdown-v2/dropdown';
import CommonUtils from '../../../utility/common-utilities';
import { Constants } from '../../../constants/constants';

class SetupClass extends Component {

    state = {
        class: [],
        board: [],
        sections: [],
        numberOfSections: 0
    }
    selectedClass = {}

    sectionsCount = Constants.SECTION_DROPDOWN

    componentDidMount() {

        this.getClassAndBoard()
    }

    getClassAndBoard(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                let classes = [], boards = [];
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }

                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }

                let selectedBoard = ""
                if (boards.length == 1) {
                    selectedBoard = boards[0].value
                }


                this.setState({ selectedBoard, class: classes, board: boards })
            }).catch(err => {
            })
    }


    getSectionsApi() {
        let payload = {
            class: this.state.selectedClass,
            board: this.state.selectedBoard
        }

        // if (!payload.class || !payload.board) return

        SchoolApi.getSections(payload)
            .then(response => {
                this.setState({ oldSections: response.response })
            }).catch(err => {
                this.setState({ oldSections: [] })
            })
    }

    onSelectSectionNumber = (option) => {
        this.setState({ numberOfSections: option?.value })
    }

    onSelectClass = (option) => {
        this.selectedClass = this.state.class.filter(item => item.value == option)[0]
        this.setState({ selectedClass: option, numberOfSections: "", reload: true }, () => {
            this.setState({ reload: false })
            this.getSectionsApi()
        })
    }

    onSelectBoard = (option) => {
        this.setState({ selectedBoard: option, numberOfSections: "", reload: true }, () => {
            this.setState({ reload: false })
            this.getSectionsApi()
        })
    }

    onSectionChangeHandler = (sections) => {
        this.setState({ sections }, () => {
            let payload = {
                class: this.state.selectedClass,
                board: this.state.selectedBoard,
                sections: this.getSections(this.state.sections)
            }
            let validation = this.validatePayload(payload, true)
            this.setState({ validation })
        })
    }

    onClickSave() {
        if (this.saving) return
        let payload = {
            class: this.state.selectedClass,
            board: this.state.selectedBoard,
            sections: this.getSections(this.state.sections)
        }
        let validate = this.validatePayload(payload)
        if (!validate) return
        this.saving = true

        SchoolApi.addSchoolsSection(payload).then(data => {
            this.saving = false
            if (this.props.onClose) {
                this.props.onClose(true)
            }
        }).catch(err => {
            this.saving = false
        })
    }

    getSections(sections) {
        let result = []
        for (let key in sections) {
            if (sections[key]) {
                let item = sections[key]
                item.order = key
                result.push(item)
            }
        }
        return result
    }


    validatePayload = (payload = {}, dontShowMessage) => {
        if (!payload.class) {
            if (!dontShowMessage) this.setState({ errorMessage: "Please select class" })
            return false
        }

        if (!payload.board) {
            if (!dontShowMessage) this.setState({ errorMessage: "Please select board" })
            return false
        }

        if (!this.state.numberOfSections) {
            if (!dontShowMessage) this.setState({ errorMessage: "Please enter section info" })
            return false
        }

        let sectionValidation = this.validateSectionPayload(payload.sections, dontShowMessage)
        if (!sectionValidation) return sectionValidation

        this.setState({ errorMessage: "" })
        return true
    }

    validateSectionPayload(sections, dontShowMessage) {

        if (!sections || !sections.length) {
            if (!dontShowMessage) this.setState({ errorMessage: `Please enter sections information` })
            return false
        }

        for (let i = 0; i < sections.length; i++) {
            let section = sections[i]

            if (!section.sectionName) {
                if (!dontShowMessage) this.setState({ errorMessage: `Please enter name for section ${section.order}` })
                return false
            }

            if (!section.strength) {
                if (!dontShowMessage) this.setState({ errorMessage: `Please enter class strength for section ${section.order}` })
                return false
            }

            if (!section.teacher) {
                if (!dontShowMessage) this.setState({ errorMessage: `Please select math teacher for section ${section.order}` })
                return false
            }

            // if (!section?.students || !section.students?.length) {
            //     this.setState({ errorMessage: `Please upload student information for section ${section.order}` })
            //     return false
            // }

            if (section?.students?.length) {
                let validate = this.validateStudentPayload(section?.students, section?.sectionName, i, dontShowMessage)
                if (!validate) {
                    return false
                }
            }
        }
        return true
    }

    validateStudentPayload(students, sectionsName, dontShowMessage) {
        for (let i = 0; i < students.length; i++) {
            let student = students[i]
            if (!student.name) {
                if (!dontShowMessage) this.setState({ errorMessage: `please enter student name at section ${sectionsName} line no: ${i + 2}` })
                return false
            }

            if (!student.contactNumber && !student.contactEmail) {
                if (!dontShowMessage) this.setState({ errorMessage: `Please add Contact number or email at section ${sectionsName} line no: ${i + 2}` })
                return false
            }

            if (student.contactNumber && !student.countryCode) {
                if (!dontShowMessage) this.setState({ errorMessage: `Please add country code at section ${sectionsName} line no: ${i + 2}` })
                return false
            }

            if (student.contactEmail && !this.validateEmail(student.contactEmail)) {
                if (!dontShowMessage) this.setState({ errorMessage: `please enter student contact email at section ${sectionsName} line no: ${i + 2}` })
                return false
            }

            if (!student.type) {
                if (!dontShowMessage) this.setState({ errorMessage: `please enter type at section ${sectionsName} line no: ${i + 2}` })
                return false
            }

            if (!student.rollNumber) {
                if (!dontShowMessage) this.setState({ errorMessage: `please enter student role number at section ${sectionsName} line no: ${i + 2}` })
                return false
            }

        }
        return true
    }


    validateEmail(value) {
        if (value) {
            let isValid = CommonUtils.validateEmail(value);
            if (!isValid) {
                this.setState({ isInvalidEmail: true });
                return false
            }
            else {
                this.setState({ isInvalidEmail: false })
                return true
            }
        } else {
            this.setState({ isInvalidEmail: true });
            return false
        }
    }

    render() {
        return (
            <div className="setup-class pb-5">

                {
                    this.state.board?.length > 1 && <div className='pt-4'>
                        <PillButton key={'board'} value={this.state.selectedBoard} options={this.state.board} onSelect={this.onSelectBoard} size={'md'} style={{ fontSize: 17, fontWeight: 'bold' }} />
                    </div>
                }

                <div className='pt-4'>
                    <PillButton key={'classes'} value={this.state.selectedClass} options={this.state.class} onSelect={this.onSelectClass} size={'md'} style={{ fontSize: 17, fontWeight: 'bold' }} />
                </div>

                {
                    !this.state.selectedClass ?
                        <div className='pt-2'>
                            <strong>Select a class to add section</strong>
                        </div>
                        : ""
                }
                {
                    this.state.selectedClass && this.state.selectedBoard && <div className='pt-5'>
                        {/* <div className='row'> */}
                        <div className='d-inline-block pt-2'>
                            <span className='section-count-text'>HOW MANY SECTIONS ARE THERE IN {this.selectedClass.title.toUpperCase()}?</span>
                        </div>

                        <div className='d-inline-block ml-4'>
                            {
                                !this.state.reload ?
                                    <Dropdown
                                        placeholder='Select'
                                        options={this.sectionsCount}
                                        onSelect={(option) => this.onSelectSectionNumber(option)}
                                        style={{ background: "#F6F7F5" }}
                                        text={"title"}
                                        value={this.state.numberOfSections}
                                    /> : ""
                            }
                        </div>

                        {/* </div> */}


                    </div>
                }

                {
                    this.state.selectedClass && this.state.selectedBoard && this.state.numberOfSections ? <div>
                        <AddSection numberOfSections={this.state.numberOfSections} oldSection={this.state.oldSections} onChange={this.onSectionChangeHandler} disableAddStudent={this.props.disableAddStudent} modalType={this.props.modalType} />
                    </div> : ''
                }

                {this.state.selectedClass && this.state.selectedBoard && this.state.numberOfSections ?
                    <div className='mt-4 text-center'>
                        {this.state.errorMessage ? <div className="text-danger pb-4"><strong>{this.state.errorMessage} </strong></div> : ""}
                        <div className={`cw-button-md ${!this.state.validation ? "disable-button" : ""}`} onClick={() => this.onClickSave()}>Save</div>
                    </div> : ''}

            </div>
        );
    }
}

export default SetupClass;